import isEqual from 'fast-deep-equal';
export { isEqual };
//# sourceMappingURL=is-equal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts-for-react/esm/helper/is-equal.js
// module id = 6752
// module chunks = 0